const Mototechnika = () => {
	return <h1>Strona w przygotowaniu</h1>;
};

export default Mototechnika;
